import { Component } from '@angular/core';

@Component({
    selector: 'app-anonymous-layout',
    templateUrl: './anonymous-layout.component.html'
})
export class AnonymousLayoutComponent {}
